<template>
  <div class="print">
    <!-- SOURCE -->
    <div
      class="print-button"
    >
      <div
        class="print-button__block"
        @click="print"
      >
        {{ text }}
        <i class="pro-icon-pdf" />
      </div>
    </div>
    <div
      ref="printMe"
    >
      <slot />
    </div>
    <img
      class="print-image"
      ref="printImage"
      :src="output"
    />
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
export default {
  name: 'PrintPage',
  props: {
    text: {
      type: String,
      default: 'Получить в pdf'
    }
  },

  data () {
    return {
      output: ''
    }
  },

  methods: {
    async print() {
      const el = this.$refs.printMe;
      const options = {
        type: 'dataURL'
      }
      const img = await this.$html2canvas(el, options);
      this.output = img

      setTimeout(() => {
        this.savePdf(img)
      }, 300)
    },

    savePdf (output) {
      const printImg =  this.$refs.printImage
      console.log(printImg.width, printImg.height)
      const doc = new jsPDF();
      doc.addImage(output, 'png', 10, 10, printImg.width / 7, printImg.height / 7)
      doc.save("a4.pdf");
    }
  }
}
</script>
<style lang="scss">
  .print {
    &-image {
      display: none;

    }
    &-button {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-bottom: 40px;

      &__block {
        border: 1px solid silver;
        display: inline-block;
        padding: 5px 10px;
        font-size: 20px;
        font-weight: 600;
        right: 0;
        cursor: pointer;
      }
    }
  }
</style>
